export default "__VITE_ASSET__BYYAXMVd__"